module.exports = __webpack_public_path__ + "assets/img/21_1110.bc4609da.jpg";